import tariffHelper from "@/helpers/tariffHelper"
import { IUnitRates } from "../tariff/tariff.types"
import { ITariffDetails } from "./tariffDetails.types"

export class TariffDetails implements ITariffDetails {
  constructor(
    public code: string,
    public gspGroup: string,
    public displayName: string,
    public standingCharge: number,
    public earlyTerminationCharge: number,
    public unitRates: IUnitRates,
    public unitRate?: number,
  ) {}

  get isGas(): boolean {
    return tariffHelper.isGas(this.code)
  }
}
